module.exports = __webpack_public_path__ + "img/app_passes_screen.4e4970c3.png";